module.exports = __webpack_public_path__ + "95b56cddd399dbae4362dfdc228495eb.pdf";